module.exports = __webpack_public_path__ + "static/media/LG 24_18sec.7b6e9fa9.mp3";